<template>
  <div class="FillInTheBlanks answerarea-item fontsize-16" :id="questionitem.innerid">
    <div class="topic-types">
        <p class="name" v-if="!isMaterialsItem"><span>{{questionitem.questionindex}}.</span>{{questionitem.questiontypename}}，本题{{questionitem.quesscore}}分</p>
        <p class="name" v-else><span>{{questioninfo.questionindex}}.{{questionitem.questionindex}}</span>{{questionitem.questiontypename}}，本题{{questionitem.quesscore}}分</p>
        <p class="title" v-html="questionitem.subject"></p>
        
        <div class="option-list">
            <div class="option-item">
                <el-input type="textarea" v-model="questionitem.uselanswer" :disabled="examstatus == 1"></el-input>
            </div>
        </div>
      </div>
      <div class="topic-types answer" v-if="examstatus == 1 || isshow == 1">
        <p>
          <span>本题得分：</span>
          <span class="fraction">
            <template v-if="ischeckover == 1">{{questionitem.userscore}}</template>
            <template v-else>--</template>分</span>
        </p>
        <p>
          <span>参考答案：</span>
          <span>{{questionitem.referenceanswer}}</span>
        </p>
        <p>
          <span>答案解析：</span>
          <span v-html="questionitem.quesanalysis"></span>
        </p>
      </div>
  </div>
</template>

<script>
export default {
  name: 'FillInTheBlanks',
  props: ['questionitem',  'examstatus', 'isshow', 'ischeckover', 'isMaterialsItem', 'questioninfo'], // 试题列表 试卷提交状态 是否显示正确答案
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {},
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss" scope>
.FillInTheBlanks {
  .el-textarea {
    margin-left: 28px;
    width: calc(100% - 80px);
    height: 160px;
    textarea {
      height: 100%;
    }
  }
}
</style>